module.exports = __webpack_public_path__ + "static/media/pigo_4.caf3bdec.png";